// Javascript to enable link to tab
var url = document.location.toString();
var showFirstTab = true;
if (url.match('#')) {
    var $targetedTab =  $('.nav-tabs a[href="#' + url.split('#')[1] + '"]');
    if($targetedTab.length > 0){
        showFirstTab = false;
        $targetedTab.tab('show');
    }

}
if(showFirstTab){
    $('.nav-tabs a.tabActivator:first').tab('show');
}

// Change hash for page-reload
$('.nav-tabs a').on('shown.bs.tab', function (e) {
    // window.location.hash = e.target.hash;
})

